module.exports = __webpack_public_path__ + "static/media/card4.7e76d70c.jpg";